import React from 'react'

import Typography from 'components/atoms/Typography'
import { Container, Row, Col } from 'components/qstrap'
import Testimony from './Testimony'

const testimonies = [
  {
    id: 1,
    name: 'Mr. Vinei',
    testimony: '“Saya merasa sangat senang setelah tahu bahwa saya bisa bekerja di Jepang, karena saya bisa mendapatkan kesempatan untuk menantang diri sendiri dengan menggunakan semua keterampilan dan pengetahuan yang saya peroleh saat kuliah. Di KIT Cambodia, saya telah belajar keterampilan teknis serta keterampilan komunikasi. Hal-hal ini membantu saya bekerja secara profesional. Saya punya rencana untuk memulai perusahaan IT saya sendiri setelah kembali dari Jepang.”',
    img: '/assets/img/kit-landing/testimonies/mr-viney-kit-cambodia-quipper-campus.jpg',
    imgAlt: 'Mr Viney KIT Cambodia | Quipper Campus',
  },
  {
    id: 2,
    name: 'Mr. Kim Cheng',
    testimony: '“Saya sangat senang mendapat kesempatan untuk bekerja di Jepang dengan lingkungan kerja baru dan mendapatkan pengalaman. KIT Cambodia telah membantu meningkatkan Bahasa Inggris, keterampilan komunikasi, keterampilan memimpin, serta memberikan kesempatan belajar. Setelah bekerja di Jepang, saya ingin berbagi pengalaman kerja dan ingin membantu teman-teman di kampus untuk menemukan peluang kerja mereka. Untuk semua junior, "Jangan ragu dan kejar passionmu!”',
    img: '/assets/img/kit-landing/testimonies/mr-kim-cheng-kit-cambodia-quipper-campus.jpg',
    imgAlt: 'Mr Kim Cheng KIT Cambodia | Quipper Campus',
  },
]

const Testimonials = () => (
  <div id="testimonials" className="testimonials">
    <Container>
      <Typography component="h2" variant="title" className="testimonials__title text-center">
        Testimoni
      </Typography>
      <Row>
        <Col md="12">
          {
            testimonies.map((testimony, idx) => (
              <Testimony key={`testimony-${idx}`} {...testimony}/>
            ))
          }
        </Col>
      </Row>
    </Container>
  </div>
)

export default Testimonials
